import { timer } from 'rxjs/observable/timer';
import { Component, Input, Injector, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Events } from 'ionic-angular';
import { Domanda_super } from './domanda_super';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operator/map';
import { CircleProgressComponent } from 'ng-circle-progress';
import moment from 'moment';
import 'moment-timer';
import { interval } from 'rxjs/observable/interval';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operator/share';
import { take } from 'rxjs/operator/take';
import { Util } from '../../app/util';
import { GlobalserviceProvider } from '../../providers/globalservice/globalservice';



/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'fit_13',
  templateUrl: 'fit_13.html',
})

export class Fit_13Component extends Domanda_super implements AfterViewInit {

  @Input('domanda') domanda: any;
  @Input('mq') mq: any;
  @Input('settingsmq') settingsmq: any;
  output: any;
  prima_parte = [];
  seconda_parte = [];
  iselect_opened = [];
  risp = [];
  risposte_selezionabili = [];
  rispbutton = [];
  risposte_conferma = [];
  showconferma: boolean = true;
  showfeed: boolean = false;
  feed = '';
  count_domande = 0;
  showtime: boolean = true;
  second_timer = 0;
  timer_sec = 0;
  title_sec = '';
  tempo_di_pausa = 4;
  tempo_start_iniziale = 6;
  timesx = 'START';

  stato;
  giro_attuale;
  @ViewChild('circletimer') circletimer: CircleProgressComponent;
  constructor(public events: Events, inj: Injector, public translate: TranslateService,public globalservice: GlobalserviceProvider) {
    super(inj);
    this.output = 'test string';
    // this.timesx = moment.duration(1000000);
    // this.timesx = moment.duration(1000, 'seconds');

    this.stato = 'stop';
    this.girobonus = false;

  }

  intaux;
  rispostaaux = { start: 0, end: 0, bonus: 0 };
  start_tempo() {
    var startTimestamp = 0;
    this.intaux = setInterval(() => {
      startTimestamp++;
      this.timesx = moment.unix(startTimestamp).format('mm:ss');
    }, 1000);
    this.rispostaaux.start = Date.now();
  }

  // start_pausa() {
  //   var si = setInterval(()=> {
  //     // startTimestamp++; 
  //     // this.timesx = moment.unix(startTimestamp).format('mm:ss');
  //     let el = this.circletimer.animate();
  //     this.timer_sec = this.timer_sec - 1;
  //     this.title_sec = '' + this.timer_sec;
  //     if (this.timer_sec == 0){
  //       clearInterval(si);
  //       this.start_tempo();
  //     }

  //   }, 1000);
  // }
  taux;
  girobonus = false;

  giro_bonus_sec;
  girobonusinput = false;
  girobonusno = false;
  fine_girobonus = false;
  risp_giro(r) {
    if(r == 0)
      this.events.publish('get_feedback_fit',this.mq,this.domanda.id,this.risposte_conferma);
    this.girobonus = false;
    if (r == 0)
      this.girobonusno = true;
    // this.prosegui();
    else {
      this.girobonusinput = true;

    }
  }
  risp_giro_input() {
    this.girobonusinput = false;
    // console.log(this.giro_bonus_sec);
    this.rispostaaux.bonus = parseInt(this.giro_bonus_sec);
    this.stato = 'incorso';
    this.start_tempo();
  }
  risp_giro_no() {
    this.girobonusno = false;
    this.prosegui();
  }
  risp_post_giro_bonus(){
    this.fine_girobonus = false;
    this.prosegui();
  }
  countdown(t) {
    // if (t > 0) {
    this.taux = t;
    // var sound = document.getElementById("sound1");
    
    var si = setInterval(() => {
      // startTimestamp++; 
      // this.timesx = moment.unix(startTimestamp).format('mm:ss');

      
      this.timer_sec = this.taux - 1;
      this.taux = this.taux - 1;
      this.title_sec = '' + this.taux;
      if(this.timer_sec < 11){
        const audio = new Audio('assets/beep.wav');
        audio.play();
      }
      let el = this.circletimer.animate();
      if (this.timer_sec == 0) {
        // console.log('giro attuale', this.giro_attuale);
        clearInterval(si);
        // if (this.giro_attuale == 0) {
        //   //richiedi giro bonus

        //   this.girobonus = true;
        //   // this.prosegui();
        // }
        // else if (this.giro_attuale == -1) {
        //   this.prosegui();
        // }
        // else {

        this.stato = 'incorso';
        this.start_tempo();
        // }
      }

    }, 1000);
    // }
    // else{
    //   //chiedo giro bonus
    //   this.girobonus = true;
    // }
    // setTimeout(() => { 
    //   if (this.circletimer != undefined) {
    //     let el = this.circletimer.animate();
    //     this.timer_sec = this.timer_sec - 1;
    //     this.title_sec = '' + this.timer_sec;
    //   }
    //   if (this.timer_sec > 0)
    //     this.timerx();
    // }, 1200);
  }

  frase_completa = '';
  risp_estatte = [];
  blocchi = [];
  ngOnInit(): void {
    this.events.publish('start_tempo', this.domanda);
    this.giro_attuale = parseInt(this.domanda['giri']);
    // console.log(this.giro_attuale);
  }


  ngAfterViewInit(): void {
    // // setTimeout(() => {
    //   this.timerx();
    // }, 100);
    // console.log(this.domanda);

    ///DA DECOMMENTARE
    this.tempo_di_pausa = this.domanda.pausaGiro;
  }

  start() {
    // this.incorso = true;
    this.stato = 'start';

    this.countdown(this.tempo_start_iniziale);
  }
  stop() {
    // this.incorso = false;
    
    this.rispostaaux.end = Date.now();
    this.store_giro();
    clearInterval(this.intaux);
    this.timesx = 'STOP';
    this.giro_attuale = this.giro_attuale - 1;
    if (this.giro_attuale == 0) {
      this.stato = 'finito';
      if (this.settingsmq.mostraGiroBonus == true)
        this.girobonus = true;
      else {
        this.prosegui();
      }

      // this.countdown(this.tempo_di_pausa);
    }
    else if (this.giro_attuale == -1) {
      //finito il girobonus
      this.events.publish('get_feedback_fit',this.mq,this.domanda.id,this.risposte_conferma);
      this.fine_girobonus = true;
      // this.prosegui();
      
      this.stato = 'finito';
      // this.countdown(this.tempo_di_pausa);
    }
    else {
      this.stato = 'inpausa';
      this.timesx = 'START';
      this.countdown(this.tempo_di_pausa);
    }


  }
  giri = [];
  store_giro() {
    this.risposte_conferma.push(this.clone(this.rispostaaux));
    var second = (this.rispostaaux.end - this.rispostaaux.start) / 1000;
    this.giri.push(new Date(second * 1000).toISOString().substr(11, 8));
    // console.log(this.risposte_conferma);
  }
  prosegui() {



    // console.log(this.risposte_conferma);
    // this.rispostaaux = {start:0,end:0};
    // if(this.giro_attuale == 0)
    //   this.events.publish('fit_next', this.domanda, this.risposte_conferma);
    // else
    this.events.publish('stop_tempo', this.domanda);
    this.events.publish('fit', this.domanda, this.risposte_conferma);
  }

  conferma(tempo?) {
    this.prosegui();
  }

  clone(obj) {
    let copy = (JSON.parse(JSON.stringify(obj)));
    return copy;
  }

}



// WEBPACK FOOTER //
// ./src/pages/msteps/fit_13.ts